'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validators = undefined;

var _reactIntl = require('react-intl');

var _validators = require('validators');

var messages = (0, _reactIntl.defineMessages)({
  invalidBirthDate: {
    id: 'device.info.invalidBirthDate',
    defaultMessage: 'Please enter a valid date of birth.'
  },
  underageBirthDate: {
    id: 'device.info.underageBirthDate',
    defaultMessage: 'Sorry, you must be at least 18 years old.'
  },
  invalidWeight: {
    id: 'device.info.invalidWeight',
    defaultMessage: 'Please enter a valid weight.'
  },
  missingGender: {
    id: 'device.info.missingGender',
    defaultMessage: 'Please select your gender.'
  }
});

var isMissing = function isMissing(value) {
  return value === undefined || value === '' || value === null;
};
var isValidForAllFields = function isValidForAllFields(values) {
  return values.every(function (value) {
    return !isMissing(value);
  });
};

var validators = exports.validators = function validators(data) {
  var errors = {};
  var birthDateDay = data.birthDateDay,
      birthDateMonth = data.birthDateMonth,
      birthDateYear = data.birthDateYear,
      gender = data.gender,
      weight = data.weight;


  if (isMissing(gender) || gender === 'Unspecified') {
    errors.gender = messages.missingGender;
  }
  if (isMissing(birthDateMonth)) {
    errors.birthDateMonth = messages.invalidBirthDate;
  }
  if (isMissing(birthDateDay)) {
    errors.birthDateDay = messages.invalidBirthDate;
  }
  if (isMissing(birthDateYear)) {
    errors.birthDateYear = messages.invalidBirthDate;
  }
  var dateOfBirth = String(birthDateYear).padStart(4, 0) + '-' + String(birthDateMonth).padStart(2, 0) + '-' + String(birthDateDay).padStart(2, 0);
  var dateOfBirthError = (0, _validators.dateOfBirthValidator)(dateOfBirth);

  if (isValidForAllFields([birthDateDay, birthDateMonth, birthDateYear]) && dateOfBirthError) {
    errors.birthDateYear = dateOfBirthError;
  }
  if (/\D/.test(weight) || weight < 10 || weight > 999) {
    errors.weight = messages.invalidWeight;
  }
  return errors;
};